import CreditCard from "./components/CreditCard";

function App() {
  return (
    <CreditCard/>
  );
}

export default App;